import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { MobileSidebar } from './MobileSidebar';
import { RightSidebar } from './RightSidebar';
import { BottomNav } from './BottomNav';
import { TopNav } from './TopNav';
import { Toaster } from '@/components/ui/sonner';
import CommandPalette from '@/components/search/CommandPalette';
import { cn } from '@/lib/utils';

// Routes where RightSidebar should be shown
const ROUTES_WITH_RIGHT_SIDEBAR = ['/', '/discover', '/briefs', '/videos'];

export const Layout = ({ children }) => {
  const location = useLocation();
  const showRightSidebar = ROUTES_WITH_RIGHT_SIDEBAR.includes(location.pathname);
  const [commandPaletteOpen, setCommandPaletteOpen] = useState(false);

  // Global keyboard shortcut for command palette
  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        setCommandPaletteOpen(true);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  // Warm cream rather than a cool grey. It is the ground the brand sits on, and
  // it is what stops a page of white cards reading as clinical.
  return (
    <div className="min-h-screen bg-cream dark:bg-zinc-950">
      <TopNav onSearchClick={() => setCommandPaletteOpen(true)} />
      <div className="flex">
        {/* Left Sidebar - Hidden on mobile/tablet */}
        <Sidebar />
        
        {/* Mobile Sidebar Drawer */}
        <MobileSidebar />
        
        {/* Main Content Area */}
        <main className="flex-1 pb-20 lg:pb-0 min-h-[calc(100vh-64px)] overflow-x-hidden">
          <div className="flex gap-2 lg:gap-[10px] px-3 lg:pl-[10px] lg:pr-4 pt-2 lg:pt-[10px]">
            {/* Feed - Full width on mobile, constrained on desktop */}
            <div className={cn("w-full min-w-0", showRightSidebar && "lg:max-w-3xl")}>
              {children}
            </div>
            {/* Right Sidebar - Only on Explore/Discover pages, hidden on mobile */}
            {showRightSidebar && <RightSidebar />}
          </div>
        </main>
      </div>
      <BottomNav />
      <Toaster position="top-center" />
      
      {/* Command Palette - Global Search */}
      <CommandPalette 
        open={commandPaletteOpen} 
        onOpenChange={setCommandPaletteOpen} 
      />
    </div>
  );
};
